export default __webpack_public_path__ + "static/media/4.1587f4a3.svg";